"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGlobalOptions = void 0;
const store_1 = require("svelte/store");
const store_2 = require("../store");
const globalOpts = (0, store_1.get)(store_2.globalOptions);
const getGlobalOptions = () => {
    return globalOpts;
};
exports.getGlobalOptions = getGlobalOptions;
/**
 * Override global options
 *
 * @param options - The global options
 */
const setGlobalOptions = (options) => {
    store_2.globalOptions.update(() => Object.assign(globalOpts, options));
};
exports.default = setGlobalOptions;
